<template>
	<v-container fluid>
		<v-row
			dense
		>
			<!-- search -->
			<v-col
				cols = "12"
				
			>
				<v-card outlined>
					
					<v-card-title
						class = "secondary pa-0  px-2 body-1 black--text"
					>	
						<v-icon 
							small 
							color  = "blue"
							class  = "mx-1"
							@click = "$router.back()"
						>
							mdi-play-box-multiple
						</v-icon>
						<strong
							class = "white--text"
						>
							
							{{ $ml.get('playback') }}
						</strong>
						
						<v-spacer></v-spacer>
						
						<v-icon 
							small 
							color  = "white"
							class  = "ml-1"
							@click = "$router.back()"
						>mdi-arrow-left-circle</v-icon>
					</v-card-title>
					<v-card-text
						class = "pa-1"
					>
						
						<v-row>
							<template
								v-for = "(item_search, idx_search) of info_search_fields"
							>
								<v-col
									:key  = "idx_search"
									:cols = "item_search.cols.col"
									v-if  = "item_search.visible"

								>
									<v-select
										v-if 		= "item_search.type == 'select'"
										dense
										outlined
										hide-details
										:items 	  	 = "render_listed(item_search.list)"
										:label         = "$ml.get(item_search.text)"
										v-model  	 = "info_search[item_search.key]"
										:item-value	 = "item_search.key_list"
										:item-text 	 = "item_search.text_list"
										:placeholder = "$ml.get(item_search.placeholder)"
										:multiple	 = "item_search.multiple"
										@input 		 = "render_analytic_option(item_search.key, info_search[item_search.key])"
									></v-select>
									<!-- get_list();  -->
									<searcher
										v-if 			   = "item_search.type == 'select_searcher'"
										:info_to_component = "item_search"
										:info_to_list  	   = "render_listed(item_search.list)"
										@receive_info	   = "info_search[item_search.key] = $event"
									></searcher>

									<v-text-field
										dense
										outlined
										:key 			= "item_search.key + idx_search"
										v-model 		= "info_search[item_search.key]"
										:label       	= "$ml.get(item_search.text)"
										:type 			= "item_search.type"
										v-if 			= "item_search.type == 'text' || item_search.type == 'number'"
										@input 			= "v => info_search[item_search.key] = v.toUpperCase()" 
									></v-text-field>
										<!-- @click 			= "keyboard_is_active(item_search.key, ID_notification, 'text', 'info_search')" -->

									<v-menu
										v-if 					= "item_search.type == 'date'"
								        ref 					= "menu"
								        v-model 				= "menu"
								        :close-on-content-click = "false"
								        transition 				= "scale-transition"
								        offset-y
								        min-width 				= "auto"
								      >
								        <!-- open-on-hover -->
								        <!-- :return-value.sync 		= "dates" -->
								        <template v-slot:activator="{ on, attrs }">
									        <v-text-field
									            v-model 			= "dates"
									          	:label              = "$ml.get(item_search.text)"
									            :placeholder        = "$ml.get(item_search.placeholder)"

									            prepend-inner-icon 	= "mdi-calendar"
									            readonly
									            v-bind 				= "attrs"
									            v-on 				= "on"
									            outlined
									            dense
									            hide-details
									            chips
									            small-chips
									            multiple		

									        >									        	
									        </v-text-field>
									        <!-- combobox -->

								        </template>
								        <v-date-picker
								          	v-model 	= "dates"
								          	no-title
								          	scrollable
								          	range
								        >
								          	<v-spacer></v-spacer>
									        <v-btn
									            x-small
									            text
									            color  = "primary"
									            @click = "actions('set_dates', dates)"
									        >
									        <!-- $refs.menu.save(dates) -->
									            
									        </v-btn>
									        <v-btn
									        	x-small
									            text
									            color  = "error"
									            @click = "menu = false"
									        >
									           
									        </v-btn>
								        </v-date-picker>
								    </v-menu>

								    	<!-- time pickers -->

								        <!-- :nudge-right 			= "40" -->
								        <!-- open-on-hover		         -->
								    <v-menu
								        offset-y						
								        :return-value.sync 		= "picker[item_search.key]"
								    	v-if 					= "item_search.type == 'time_picker'"
								        :ref 					= "item_search.ref"
								        v-model 				= "menu_picker[item_search.menu]"
								        :close-on-content-click = "false"
								        transition 				= "scale-transition"
								        max-width 				= "290px"
								        min-width 				= "290px"
								    >
								        <template v-slot:activator="{ on, attrs }">
								          	<v-text-field
									            readonly
									            outlined
									            dense
									            v-model 	 		= "picker[item_search.key]"
									            :label 		 		= "item_search.text"
									            prepend-inner-icon 	= "mdi-clock-time-four-outline"
									            v-bind 		 		= "attrs"
									            v-on 		 		= "on"
									            hide-details
								          	></v-text-field>
								        </template>
									        <!-- full-width -->
								        <v-time-picker
									        no-title
									        scrollable
									        v-if 			= "menu_picker[item_search.menu]"
									        v-model 		= "picker[item_search.key]"
									        format 			= "24hr"
									        @click:minute 	= "save_time(item_search.key, picker[item_search.key], item_search.ref)"
								        ></v-time-picker>
								    </v-menu>

								    <v-btn
								    	v-if 	= "item_search.type == 'btn'"
								    	@click 	= "actions(item_search.action)"
								    	:color  = "item_search.color"
								    >
								    	{{ $ml.get(item_search.text) }}
								    </v-btn>
								</v-col>
							</template>
						</v-row>
						<v-progress-linear
							color  = "primary"
							v-show = "loading" 
							indeterminate
						></v-progress-linear>
					</v-card-text>
				</v-card>
			</v-col>
			
			
			<!-- list playback -->
			<v-col
				cols = "12"
				v-show 	= "show" 
			
			>
				<v-card 
					outlined
					ref  = "card_segments"

				>
					<v-card-text>
						<v-row
							dense
						>
							<v-col 
								cols = "5"
							>
								

								<!-- <v-row>
									<v-col
										cols  = "12"
										class = "pt-0"
									> -->

										<v-card 
											outlined
											ref   	 = "video_play_content"
										>	
											<!-- height = "100%" -->
										<v-card-title
											class = "primary pa-0 body-2"
										>	
											<v-icon
												x-small
												color  = "white"
												class  = mx-2
											>
												mdi-video
											</v-icon>
											{{ 'Video Evidence' }}
										</v-card-title>
											<v-card-text>
												<!--  @click = "next_video()" -->
												<!-- loop 	 = "loop"  -->
												<video  
													width 	 = "100%" 
													height 	 = "88%" 
													ref   	 = "video_play"
													v-if  	 = "url_video"
													autoplay = "autoplay" 
													controls = "controls" 
													tabindex = "0"
													@ended 	 = "start_Playback()"
													@loadeddata    = "onResize()"
													>
									<!-- 										preload="auto"  -->
													<source 
													 	:src = "url_video"
													   	type = 'video/mp4' />
												</video>
											</v-card-text>
										</v-card>

									<!-- </v-col>
									
									<v-col
										cols   = "12"
										v-show = "false"
									> -->
										<!-- here go the video thumbnails -->
									<!-- </v-col>
									<v-col
										cols = "12"
										v-show 		= "false"			  
									>
										<v-card 
											outlined
										>	
											<v-card-title
												class = "success pa-0 body-2"
											>	
												<v-icon
													x-small
													color  = "white"
													class  = mx-2
													v-text = "'mdi-chart-bar-stacked'"
												></v-icon>
												{{ $ml.get('statistics') }}
											</v-card-title>
											<v-card-text >
												<v-slider	
												  	v-model   	= "slider_time"
												  	thumb-label = "always"
												></v-slider>
												<button @click="fillData()">Randomize</button>
												<div>
													
													<line></line>
													height :100px; position: relative
													<line-chart 
														:options = "{responsive : true}"
														:styles ="`" 
														:chart-data="datacollection"
													></line-chart>
												</div>
												<!- - <GChart
											 		id="chart"
											 		style="width: 100%; height: 95%; object-fit: fill;"
												    type="LineChart"
												    :data="chartData"
												    :options="chartOptions"
												    :resizeDebounce="500"
												/>		 - ->
											</v-card-text>
										</v-card>
									</v-col>
								</v-row> -->
							</v-col>
							<v-col
								cols = "7"
							>
								<v-card 
									outlined
									height 	= "100%"
								>	
									<!-- ref 	= "card_segments" -->
								<v-card-title
									class = "blue-grey darken-1 pa-0 body-2"
								>	
									<v-icon
										x-small
										color  = "white"
										class  = mx-2
									>
										mdi-pound-box
									</v-icon>
									<span>										
										{{ $ml.get('video_segments') }}
									</span>
									<v-spacer></v-spacer>
									<v-input									    		     
									    :messages 	= "[ message.msg ]"	
									    :success 	= "message.success"
									    :error  	= "message.error"
									></v-input>
								</v-card-title>
									<v-card-text>

										<v-item-group >
											<v-container fluid 
												class="pt-0 pb-1 pt-1 overflow-y-auto"  
												id="scroll-target"  
												:style="{ overflowX:'hidden', height: height+'px' }"
												 
											> <!-- 18vh -->
											<!-- height: 200px -->
												<v-row 
													v-scroll:#scroll-target = "onScroll"  
													:style = "{ height: height_row +'px'}"
													dense

												>
												
												<!-- style="height:20vh;"  -->
													<v-col 
														v-for 	= "(item_video, index_video) of videoTimeline" 
														@click 	= "sel(item_video, index_video)" 
														:key 	= "index_video" 
														xl 		= "3" 
														lg  	= "5" 
														md 		= "4" 
														sm 		= "6" 
														cols 	= "6"  
														style 	= "justify: center;"
													>
														<v-item v-slot:default="{ active, toggle }">
															<v-card 
																:color="active || item_video.active ? 'primary' : '' "  
																dark  
																style="width:80%; height: 70%"  
																@click="toggle" 
																class="pl-1 ma-0 my-1" 
																outlined
															>
																<p 
																	class = "pa-0 ma-0 text-center" 
																	style = "font-size: 80%; line-height: 110%"
																> {{ $momentz(parseInt(item_video.date,10)).format('ll, LTS') }}</p>
																  <v-scroll-y-transition>					
																  	<video  
																		:width 	= "100 + '%'" 
																		:height = "80 + '%'" 
																		:src 	= "`${$URL}${item_video.urlpath}`"	
																		:id 	= "'video_event' + index_video"					
																		v-show = "!item_video.ready"

																	></video>													                 	
													                </v-scroll-y-transition>				
													                <img
													                	width  = "100%"
													                	height = "80%"
													                	v-show = "item_video.ready"
													                	src   = "/img/no_img_found.png"
													                />
													               
															</v-card>
														</v-item>
													</v-col>
												</v-row>	
											</v-container>
										
										</v-item-group>
											<!-- v-on:change_page="page=$event" -->
									<v-bottom-navigation
										height="40"
									 	dense>
											<v-btn text :disabled="true">
										    <span>
												{{ $ml.get('number_items') }}:
										    	{{pagination.items}}
										    </span>
											</v-btn>				    
											
									     		
									     	<v-pagination
										      	v-model 		= "page"					 
											    :length 		= "pagination.total"
											    :total-visible 	= "pagination.visible"
											    dense
										    ></v-pagination>					
									</v-bottom-navigation>
										
									</v-card-text>
								</v-card>
								<v-card 
									outlined
									height 	= "100%"
									ref 	= "card_analytic"
									v-if    = "false"
								>	
								<v-card-title
									class = "blue-grey darken-1 pa-0 body-2"
								>	
									<v-icon
										x-small
										color  = "white"
										class  = "mx-2"
									>
										mdi-pound-box
									</v-icon>
									<span>										
										{{ $ml.get('analytic') }}
									</span>
									<v-spacer></v-spacer>
									<v-input									    		     
									    :messages 	= "[ message_tag.msg ]"	
									    :success 	= "message_tag.success"
									    :error  	= "message_tag.error"
									></v-input>
								</v-card-title>
									<v-card-text>

										<v-item-group >
											<v-container fluid 
												class="pt-0 pb-1 pt-1 overflow-y-auto"  
												id="scroll-target"  
												:style="{ overflowX:'hidden', height: height_tag+'px' }"
												 
											> <!-- 18vh -->
											<!-- height: 200px -->
												<v-row 
													v-scroll:#scroll-target="onScroll"  :style="{height: height_row_tag +'px'}"
													dense

												>
												
												<!-- style="height:20vh;"  -->
													<v-col 
														v-for 	= "(item_tag, index_tag) of list_tags" 
														@click 	= "select_tag(item_tag, index_tag)" 
														:key 	= "index_tag + 'tags'" 
														xl 		= "3" 
														lg  	= "5" 
														md 		= "4" 
														sm 		= "6" 
														cols 	= "6"  
														style 	= "justify: center;"
													>
														<v-item v-slot:default="{ active, toggle }">
															<v-card 
																:color = "active || item_tag.active ? 'primary' : '' "  
																dark  
																style="width:80%; height: 70%"  
																@click="toggle" 
																class="pl-1 ma-0 my-1" 
																outlined
															>
																<p 
																	class = "pa-0 ma-0 text-center" 
																	style = "font-size: 80%; line-height: 110%"
																> {{ $momentz(parseInt(item_tag.date,10)).format('ll, LTS') }}</p>
																  <v-scroll-y-transition>					
																  												                 	
													                </v-scroll-y-transition>	
													                 {{ item_tag }}
													                <!-- <img
													                	width  = "100%"
													                	height = "80%"
													                	
													                	v-show = "true"
													                	src   = "/img/no_img_found.png"
													                ></img>	 -->		             
													               
															</v-card>
														</v-item>
													</v-col>
												</v-row>	
											</v-container>
										
										</v-item-group>
											<!-- v-on:change_page="page=$event" -->
									<v-bottom-navigation
										height="40"
									 	dense>
											<v-btn text :disabled="true">
										    <span>
												{{ $ml.get('number_items') }}:
										    	{{pagination_tag.items}}
										    </span>
											</v-btn>				    
											
									     		
									     	<v-pagination
										      	v-model 		= "page_tag"					 
											    :length 		= "pagination_tag.total"
											    :total-visible 	= "pagination_tag.visible"
											    dense
										    ></v-pagination>					
									</v-bottom-navigation>
										<v-progress-linear
											color  = "primary"
											v-show = "loading_tag" 
											indeterminate
										></v-progress-linear>
									</v-card-text>
								</v-card>
							</v-col>
						</v-row>	

					</v-card-text>
					<!-- <v-card-actions>
						
					</v-card-actions>	 -->
				</v-card>

			</v-col>
			<v-col
				cols = "12"
				
			> 
				<!-- v-show = "items && items.length > 1" -->
				<v-card
					outlined
				>
					<v-card-text>
						<v-row>
							<v-col

							>
									<!-- Timeline component removed - using D3.js timeline instead -->
									<!-- <timeline 
										ref 	 = "timeline" 
										:items 	 = "items" 
										:groups  = "groups" 
										:options = "options_timeline"
									></timeline> -->

							</v-col>
						</v-row>
					</v-card-text>
				</v-card>

			</v-col>

			<!-- play video -->
			<!-- <v-col
				cols 	= "12"
				v-show 	= "show" 
			>	
				
			</v-col> -->
		</v-row>
		
	</v-container>
</template>
<script>
	// import { GChart } from 'vue-google-charts'
	// import  Line  from 'vue-chartjs'
	// console.log(Line, "VUE chart")
	// import LineChart from '@/components/charts/line.js'
	// import events from '@/components/events/events.vue'
	import searcher from "@/components/info/searcher.vue"
	import dates from "@/components/info/dates.vue"
	import EventBus from "@/event-bus"
	import { func } from "joi";
	// import { Timeline } from "vue2vis";
	// import { DataSet } from 'vue2vis'
	// import "vue2vis/dist/vue2vis.css";

	export default{
		name 		: 'playback',
		// extends: Line,

		components  : {
			searcher,		
			dates,
			menus,
			// Timeline,
			// GChart
			// LineChart,
			// events
		}, // components
		data : (vm) => ({
			info 				: {},
			info_search 		: {
				groups: [] // Valor inicial para grupos
			},
			info_search_fields 	: [
				{
					key 		: 'search',
					text 		: 'search',
					placeholder : 'device',
					list 		: 'list_devices',
					key_list	: 'deviceId',
					text_list 	: 'name',
					type 		: 'select_searcher',
					key_search  : 'name',
					key_search_1 : 'deviceId',
					visible 	: true,
					cols 		: {
						col : 2,
					},
				},
				{
					key 		: 'dates',
					text 		: 'date',
					placeholder : 'select',
					type 		: 'date',
					visible 	: true,
					cols 		: {
						col : 3,
					},
				},
				{
					key 		: 'start',
					menu 		: 'picker_start',
					ref 		: 'menu_start',
					text 		: 'Start',
					placeholder : 'time',
					type 		: 'time_picker',
					visible 	: true,
					cols 		: {
						col : 2,
					},
				},
				{
					key 		: 'end',
					menu 		: 'picker_end',
					ref 		: 'menu_end',
					text 		: 'End',
					placeholder : 'time',
					type 		: 'time_picker',
					visible 	: true,
					cols 		: {
						col : 2,
					},
				},
				{
					key 		: 'analytic',
					text 		: 'analytic',
					placeholder : 'select',
					list 		: 'list_analytics',
					key_list	: 'name',
					text_list 	: 'name',
					type 		: 'select',
					multiple 	: false,  
					visible 	: false,
					cols 		: {
						col : 1,
					},
				},
				
				// option ext
				{
					key  :  'plate_char',
					text :  'plate',
					type :  'text',
					visible 	 : false,					
					placeholder  : 'type a plate',
					ref_analytic : 'lpr',
					cols 		: {
						col : 1,
					},

				},
				{
					key 		: 'tags',
					text 		: 'tags',					
					list 		: 'list_objects',
					placeholder : 'select',
					ref_analytic : 'object',					
					/*key_list	: 'name',
					text_list 	: 'name',*/
					type 		: 'select',
					multiple 	: true,  
					visible 	: false,
					cols 		: {
						col : 1,
					},
				},
				{
					key 		: 'motion',
					text 		: 'motion',					
					list 		: 'list_motions',
					placeholder : 'select',
					ref_analytic : 'motion',					
					/*key_list	: 'name',
					text_list 	: 'name',*/
					type 		: 'select',
					multiple 	: true,  
					visible 	: false,
					cols 		: {
						col : 1,
					},
				},
				{
					key 		: 'anomalies',
					text 		: 'anomalies',					
					list 		: 'list_anomalies',
					placeholder : 'select',
					ref_analytic : 'anomalies',					
					/*key_list	: 'name',
					text_list 	: 'name',*/
					type 		: 'select',
					multiple 	: true,  
					visible 	: false,
					cols 		: {
						col : 1,
					},
				},
				{
					key  :  'entity',
					text :  'face',
					type :  'select_searcher',					
					list :  'list_entitys',
					placeholder : 'select',
					ref_analytic : 'face',					
					key_list	: 'name',
					text_list 	: 'name',
					type 		: 'select',
					key_search  : 'name',
					key_search_1 : 'id_tracker',
					multiple 	: true,  
					visible 	: false,
					cols 		: {
						col : 1,
					},
				},
				{
					key  :  'actions',
					text :  'actions',
					type :  'select',
					list : 'list_actions',
					placeholder : 'select',
					ref_analytic : 'actions',
					multiple 	: true,
					visible 	: false,
					cols 		: {
						col : 1,
					},
				},
				{
					key 		: 'groups',
					text 		: 'groups',
					type 		: 'select',
					list 		: 'list_groups',
					key_list	: 'value',
					text_list 	: 'text',
					placeholder : 'select_groups',
					multiple 	: true,
					visible 	: true,
					cols 		: {
						col : 1,
					},
				},
				{
					key 		: 'btn',
					action 		: 'search',					
					ref 		: 'search',
					text 		: 'search',
					placeholder : 'btn',
					type 		: 'btn',
					color 		: 'primary',
					visible 	: true,
					cols 		: {
						col : 1,
					},
				},


			],
			list_devices 	: [],
			list_search 	: [],
			menu 		 	: false,
			dates 		 	: [], 	
			menu_picker 	: {
				start	: false, // menu
				end		: false,			
			},
			picker 			: {
				start	: "00:00", // 
				end		: "23:59",
			},

			show 		 	: true,
			ID_notification : 'playback',
			options 		: { itemsPerPage : 30 },
			total 			: 0,
			chartData 		: [
		        ['Time', 'Guns', 'Person', 'Pet', 'LPR'],//'Year', 'Sales', 'Expenses', 'Profit'
		        ['7:00 ', 100, 400, 10, 200 ],
		        ['10:00', 80, 460, 80, 300],
		        ['12:00', 30, 1120, 60, 222],
		        ['15:00', 25, 540, 100, 1234]
		      ],
		    chartDataTags 	 : {},
		    chartOptionsDate : {},
		    chartOptionsTags : {},
	      	chartOptions 	 : {
		        chart : {
		          title 	: 'Events', //Company Performance
		          subtitle 	: 'daily, weekly', //Sales, Expenses, and Profit: 2014-2017

		        },
	        	colorAxis 	: { colors: ["blue", "pink", "green", "red"] },
	        	chartArea 	: {
				    fill 		: '#FF0000',
          			fillOpacity : 0.1,


				},
				backgroundColor : {
			        gradient : {
			          // Start color for gradient.
			          color1 : '#121212',
			          // Finish color for gradient.
			          color2 : '#121212',
			          // Where on the boundary to start and
			          // end the color1/color2 gradient,
			          // relative to the upper left corner
			          // of the boundary.
			          x1 	 : '0%', y1: '0%',
			          x2 	 : '100%', y2: '100%',
			          // If true, the boundary for x1,
			          // y1, x2, and y2 is the box. If
			          // false, it's the entire chart.
			          useObjectBoundingBoxUnits: true
        			},
      			},
        		hAxis : {
				    textStyle:{color: '#FFF'}
				},
				vAxis : {					
					textStyle : { color : '#FFF'},				
				    gridlines : { color : '#787878'}
				},
				legend : {
					textStyle : { color : '#FFF'}
				},
				width  : '100%',
				height : '100%'
	     	},
	     	size_height		: 100,
			size_width 		: 100,
			videoTimeline:[],
			indexPLay:0,
			video:{
				urlpath:""
			},
			url_video : vm.$URL,
			list_analytics : [ 
				'lpr', 
				'motion', 
				'object', 
				'face', 
				/*'gun', 
				'person', 
				'human actions', 
				*/
				'actions',
				'anomalies'
			],
			list_analytics_tags : [ // for no have second option
				/*'lpr' ,
				'object' ,	
				'face'   ,				
				'actions',*/
				'anomalies', 
				'motion',
			],
			select_idx_analytic : null,
			datacollection : null,
			height : 100,
			pagination:{
				visible: 5,
				total: 0,			
				items: 0,
				found: true,
				
			},
			page: 1,
			offsetTop: 0,
			height_row : 370,
			slider_time : 1,
			sliders : {
				max : 200,
				min : 1
			},
			loading : false,
			message : {
				msg     : '',
				success : false,
				error   : false,
			},
			list_tags 		: [],
			height_tag 		: 100,
			height_row_tag 	: 370,
			pagination_tag  : {
				visible : 5,
				total   : 0,			
				items   : 0,
				found   : true,
				
			},
			page_tag 		: 1,
			offsetTop_tag  	: 0,
			loading_tag 	: false,
			message_tag  	: {
				msg     : '',
				success : false,
				error   : false,
			},
			list_actions : [
				'Hands -up',
				'Walking',
				'Fighting',
				'Calling',
				'Falling',
				'Sitting',
				'Standing',						
			],
			list_objects : [
				'person',
				'gun',				
				'car'
										
			],
			list_entitys : [],
			list_anomalies : ['anomalies'],
			list_motions   : ['motion'],
			list_groups : [
				{ value: 'LPR', text: '🚗 LPR' },
				{ value: 'Actions', text: '⚡ Actions' },
				{ value: 'SmartEvent', text: '🧠 Smart Events' },
				{ value: 'Records', text: '📹 Records' },
				{ value: 'Alerts', text: '🚨 Alerts' },
				{ value: 'Objects', text: '🎯 Objects' },
				{ value: 'Axle', text: '🛞 Axle' },
				{ value: 'Counter', text: '🔢 Counter' }
			],
			first_request  : false,
			groups: [
			
                {
                    id:1,
                    content:'Objects',
                    subgroupStack: { sg_1: false, sg_2: false, sg_3: false },

                },
               /* {
                    id:2,
                    content:'Actions',
                    subgroupStack: { sg_1: false, sg_2: false, sg_3: false },

                }*/
			],
			items : [{
                id 		: 0,
                group 	: 0,
                start 	: new Date(),
                end 	: new Date(),
                content : 'Item Init',
                hidden  :true
            }],
            src_img 	: vm.$logos.login_night,
            objects 	: null, 
            options_timeline : {
				editable 		 : false,
                horizontalScroll : true,
                verticalScroll 	 : true,
                stack 			 : false
			},
		}), // data  

		created(){
			if (localStorage.getItem('list_devices')) {
				this.list_devices = JSON.parse(localStorage.getItem('list_devices'));
			}
			console.log(this.$momentz(), this.$momentz().format('L'))
			// this.dates.push(this.formatDate(this.$momentz().format('L')));
			// this.get_list();
			console.log(this.formatDate(this.$momentz().format('L')), "DATE FORMAT")
			// this.get_list();
			this.get_list_trained();

/*
			let f 	= new Date();
			console.log(f, "NEW DATE ******************")
	      	let today = f.getFullYear() +  "-" + f.getMonth()+1 + "-" + f.getDate();
			console.log(f, "DATE ******************" , today)*/

	      	// this.dates.push(today, today)
		  /*	this.dateRange.startDate=[day,"00:00"];//this.moment().format("MM-DD-YYYY").toLocaleString();
		  	this.dateRange.endDate=[day,"23:00"];// new Date() this.moment().format("MM-DD-YYYY").toLocaleString();
		  	console.log(this.dateRange.startDate, 'date')
		  	date.push(this.$momentz(new Date(this.dateRange.startDate)).format('LLLL'));
			date.push(this.$momentz(new Date(this.dateRange.endDate)).format('LLLL'));*/

		}, // created

		watch:{

			options: {
				handler(){
					// this.get_list();

				}, deep: true, 
			}, // optitons

			page: function(val){
				this.get_list();
			}, //page

			slider_time: function(current){
				if (current) {
					console.log("SLIDER : ", current, this.videoTimeline[this.indexPLay])
					if (this.videoTimeline[this.indexPLay]) {
						let video = this.videoTimeline[this.indexPLay];

						if (video && video.duration > 0 ) {
							video.element.currentTime = current;
						}
					}

				}
			}, // 

		}, // watch

		methods : {

			actions(act, item, opt){
				switch (act){
					case ('set_dates') : {
						// this.dates = item;
						this.menu = false;
					}break;
					case ('search') : {
						this.get_list(true)
					}break;
					default : {
						console.log("this option not exist ")
					}
				};
			}, // actions
			
			render_listed (list){
				return this[list];
			}, // render listed


			formatDate (date) {
		        if (!date) return null

		        const [year, month, day] = date.split('/')
		        return `${year}-${month}-${day}`
		    
		    }, // formatDate

		    // Función para obtener la fecha de inicio del día
		    getStartOfDay(date) {
		      const startOfDay = new Date(date);
		      startOfDay.setHours(0, 0, 0, 0);
		      return startOfDay;
		    },

		    // Función para obtener la fecha de fin del día
		    getEndOfDay(date) {
		      const endOfDay = new Date(date);
		      endOfDay.setHours(23, 59, 59, 999);
		      return endOfDay;
		    },
			
			save_time(key, item, ref){
 				console.log("TIME *********************" , item, this.$refs[ref], key, ref)
 				this.$refs[ref][0].save(this.picker[key])
 				this.picker[key] = item;
 				// this.$refs[item].save(picker[item_search.key])
			},
			next_video(){
				this.indexPLay++
				if ( this.videoTimeline[this.indexPLay]) {

					this.video 		= this.videoTimeline[this.indexPLay];
					this.url_video  = '';
					const timer = setTimeout(()=>{

						this.url_video  = this.video && this.video.urlpath ? 
										this.$URL+ this.video.urlpath : ''; 
						this.onResize();
						clearTimeout(timer)
					}, 500)
				}else{
					console.log("Not found video in index ", this.indexPLay);
					this.indexPLay --;
					this.render_message(this.$ml.get('data_no_found'), 'error') 
				}
			},
			start_Playback(){
				this.indexPLay++
				if (this.videoTimeline[this.indexPLay]) {

					this.video 		= this.videoTimeline[this.indexPLay]
					this.url_video  = this.video && this.video.urlpath ? 
									 this.$URL + this.video.urlpath : '';

				}else{
					console.log("No have more index for playing", this.indexPLay);
					this.indexPLay --;
				}
				
			}, // start playback

			sel(video, index){
				console.log('charge video ', video, index);
				if (video && index >= 0) {
					// console.log("charge : ", index);
					this.video 		= this.videoTimeline[index];
					this.videoTimeline[this.indexPLay].active = false;
					this.videoTimeline[index].active = true;
					this.indexPLay = index;
					this.url_video  = '';
					const timer = setTimeout(()=>{

						this.url_video  = this.video && this.video.urlpath ? 
										this.$URL + this.video.urlpath : ''; 
						// console.log("charge video 1", video);
						this.onResize();

						clearTimeout(timer)
					}, 500)
				}
			}, // sel

			onScroll (e) {
	    		this.offsetTop = e.target.scrollTop
	  		}, // onScroll

	  		onResize(val) {				
	  			console.log("Height : ****************** ", this.$refs.card_segments.$el.clientHeight, this.$refs,this.$refs.video_play_content)
			 	if (this.$refs && this.$refs.card_segments && this.$refs.card_segments.$el && this.$refs.card_segments.$el.clientHeight) {
			 		let rest 	 = 	this.$refs.card_segments.$el.clientHeight - 40; 
			 		let rest_tag = rest;
			 		const timer_resize = setTimeout(()=>{
				 		if (this.$refs.video_play) {
				 			console.log(this.$refs.video_play.clientHeight )
				 			if (this.$refs.card_segments.$el.clientHeight >= this.$refs.video_play.clientHeight ) {
				 				rest = this.$refs.video_play.clientHeight  - 40;
				 			}else{
				 				rest = this.$refs.video_play.clientHeight  - 40;
				 			}
				 			this.height 	= rest; // 145
				 			this.height_row = rest; // 145

				 		}else{

							console.log("this.$refs.video_play_content.$el.clientHeight", this.$refs.video_play_content.$el.clientHeight);

							console.log("this.$refs.video_play.clientHeight", this.$refs.video_play);
				 			if (this.$refs.video_play_content && this.$refs.video_play_content.$el && this.$refs.video_play_content.$el.clientHeight) {
				 				rest = this.$refs.video_play_content.$el.clientHeight ;
				 				this.height 	= rest; // 145
				 				this.height_row = rest;
				 			}
				 			console.log("timeout video play: ", this.$refs.video_play.clientHeight)
				 		}
				 		clearTimeout(timer_resize);
			 		}, 1500)
			 		/*if (this.$refs.card_analytic) {
			 			console.log("card_analytic :" ,this.$refs.card_analytic )
			 			// if (this.$refs.card_analytic.$el.clientHeight > rest ) {
			 				rest_tag = this.$refs.card_analytic.$el.clientHeight ;
			 				//this.height_row_tag = rest_tag //- 100;rest + 
			 			// }
			 			this.height_tag = rest_tag; // 145
			 		}*/

				}else{
					console.log("No found ref : card");
				}

			}, //on Resize

			set_time_lapse(){
				let list = this.videoTimeline;
				let vm   = this;
				vm.sliders.max = 1;
				if (list && list.length > 0) {
					let temp_video = [],
						cont = [];

					
					list.forEach((video, idx_video) => {
						temp_video[idx_video] = document.getElementById('video_event' + idx_video);
						if (temp_video[idx_video]) {
							temp_video[idx_video].load();
							cont[idx_video] = 1;
							const timer = setInterval(()=>{
								// console.log("VIDEO : ",idx_video , temp_video[idx_video].duration, temp_video[idx_video].currentTime );
								if (vm.videoTimeline[idx_video] && vm.videoTimeline[idx_video].element) {
									vm.videoTimeline[idx_video].element = temp_video[idx_video];
								}
								
								if (temp_video[idx_video].readyState >= 2) {
								
									if (temp_video[idx_video].duration && vm.videoTimeline[idx_video]) {
										vm.videoTimeline[idx_video].duration = temp_video[idx_video].duration;
										vm.sliders.max += temp_video[idx_video].duration; 
									}
									clearInterval(timer);
								}				
								if (cont[idx_video] < 7) {
									cont[idx_video]++;
								}else{
									if (vm.videoTimeline[idx_video]) {
										vm.videoTimeline[idx_video].ready = true;
									}
									clearInterval(timer);
								}				
							}, 3000)
						}
					});
				}
			}, // set time lapse

			

			get_data_axios(api, info_up, page = 0 , list = [], source){
				let  vm = this;

				// page++
				this.loading = true;
				let newapi = api+"/?page="+page
				this.$axios.post(newapi, info_up).then( res => {
					if (res){
						
						list = res.data.rows; // list.concat(res.data.rows)
		
						console.log(page,parseInt(res.data.pages),page<parseInt(res.data.pages))
						if(page == 1){
							this.onResize();
							let temp_noti = list && list.length > 0 ? true : false;
							this.$EventBus.$emit("notifications_modal",{
								type    : temp_noti ? 'success' : 'warning',
								message : temp_noti ? this.$ml.get('data_found') :  this.$ml.get('data_no_found')
							})
						}
						if (list && list.length > 0) {
							// list.reverse();
							vm.video  		 = list[0]
							// vm.url_video  = '';
							vm.videoTimeline = list;
							vm.indexPLay	 = 0;
							this.set_url_video(vm.video, 'object');

							let item 		= list.length;							
							let pages		= res.data && res.data.pages ? res.data.pages : '';
		      				
							this.pagination = {
		      					visible: 5,
								total: pages,			
								items: item,
								found: true,
		      				};
		      				if(source == 'object'){
	                            vm.objects = res.data.timeline;
								vm.FormatJsonToTimeline(res.data)
								console.log("Formated...", vm.objects)
							}

		      				this.render_message(this.$ml.get('data_found'), 'success');

						}else{
		    				this.render_message(this.$ml.get('data_no_found'), 'error') ;

							this.render_no_found()
							// this.height = 300;
						}
						// }
						/*if(page < parseInt(res.data.pages)){
							
							vm.get_data_axios(api,info_up,parseInt(page))
						}else{
							
						}*/
						
						

			    		//console.log(" Get list ", this.ID_notification);
			    		//console.log(res);

					}
		    		this.loading = false;
		    	}).catch( er => {
		    		console.log(" Error Get list ", this.ID_notification + ' : ', er);
		    		this.loading = false;		
		    		this.render_message(this.$ml.get('data_no_found'), 'error') 
		    		this.$EventBus.$emit("notifications_modal",{
						type    : 'error',
						message : this.$ml.get('data_no_found')
					});
					this.render_no_found();
		    	});

			},

			set_url_video(video, type){
				let vm 		 = this;
				vm.url_video = '';
				const timer = setTimeout(()=>{
					if (type == 'object') {

						vm.url_video = video && video.urlpath ? 
						vm.$URL + video.urlpath : '';
					}else{
						vm.url_video = video ? this.$URL + video : '';
					}
					// vm.onResize();
					// vm.set_time_lapse();

				},50)
			}, // set url video
		    
		    get_list(pag = false){
				this.videoTimeline 	= []
		    	let info_search 	= this.info_search;
		    	let info_up 		= null;
		    	let pg 				= this.page;
		    	let tags1  			= [];
		    	let entity1			= [];
		    	let plate 			= null;
		    	let groups1			= [];
		    	let timeZone 		= this.$timezone;
		    	// console.log("PICKER : ", this.picker, info_search, this.dates);
		    	if (info_search) {
		    		// render info to search
			    	let date1 = this.$momentz(this.$momentz.now()).format('YYYY/MM/DD'), // L
			    		date2 = date1;
		    		if (this.dates && this.dates.length > 0) {
		    			this.dates.sort(function(a,b){
						  // Turn your strings into dates, and then subtract them
						  // to get a value that is either negative, positive, or zero.
						  return  new Date(a) - new Date(b);
						});

		    			date1 = this.dates[0].split('-').join('/');//.replaceAll(/-/ig, '/');
		    			date2 = this.dates[1].split('-').join('/');//.replaceAll(/-/ig, '/');


		    		}else{
		    			this.dates[0] = this.$momentz(date1).format('YYYY-MM-DD');
						this.dates[1] = this.dates[0]
		    		}

	    			if (this.picker) {
	    				date1 += ' ' + this.picker.start;
	    				date2 += ' ' + this.picker.end;
	    			}

	    			date1 = this.$momentz(date1).format('YYYY/MM/DD_HH-mm-ss');
	    			date2 = this.$momentz(date2).format('YYYY/MM/DD_HH-mm-ss')
					console.log("times : ", date1, date2);

					if (info_search.tags && info_search.tags.length > 0 ) {
						tags1 = info_search.tags;
					}
					if (info_search.anomalies && info_search.anomalies.length > 0 ) {
						tags1 = tags1.concat(info_search.anomalies);
					}
					if (info_search.motion && info_search.motion.length > 0) {
						tags1 = tags1.concat(info_search.motion);						
					}
					if (info_search.actions && info_search.actions.length > 0) {
						tags1 = tags1.concat(info_search.actions);
					}

					if (info_search.entity && info_search.entity.length > 0) {
						entity1 = info_search.entity;
					}
					if (info_search.plate_char) {
						plate = info_search.plate_char;
					}

					if (info_search.groups && info_search.groups.length > 0) {
						groups1 = info_search.groups;
					}

					// set info to search
		    		info_up = {
		    			start 	 	:  date1, 
		    			end 	 	:  date2,		    			
		    			deviceId  	:  info_search.search, 
		    			tags 		:  tags1,
		    			entity 		:  entity1,
		    			plate_char  :  plate,
		    			groups 		:  groups1,
		    			timeZone

		    		}		    		


			    	if (pag) {
			    		pg = 1;
			    	}
			    	console.log("request : ******************** ", info_up);
			    	const api 	= this.$URL + '/api/v1/records/find';
			    	const api1 	= this.$URL + '/api/v1/object/find';
			    	if (info_up.deviceId) {

						this.get_data_axios(api, info_up, pg, [], "object");
			    	}else{
			    		console.log("Required : select device ")
			    		this.$EventBus.$emit('notifications_modal',{
			    			type 	: 'warning',
			    			message : this.$ml.get('req_sel_device'),
			    		});
			    	}
		    	}else{
		    		console.log( "Not info to search ", info_search)
		    	}


		    	// /api/v1/record/:id/
		    	// /api/v1/records
		    	
				/*
		    	this.$axios.post(api1, info_up).then( res1 => {
		    		console.log(" Get list tags", this.ID_notification);
		    		console.log(res1);

		    	}).catch( er1 => {
		    		console.log(" Error Get list  tag", this.ID_notification + ' : ', er1);
		    	} )*/
		    	// list_search
		    }, // get list	

		    render_message(msg, type){
		    	console.log("render message : ", msg, type)
		    	if (msg && type) {		    	
		    		this.message[type] 	= true;
		    		this.message.msg 	= msg; 
		    		const timer = setTimeout(()=>{
		    			this.message[type] = false;
		    			this.message.msg   = ''; 
		    			clearTimeout(timer);
		    		}, 2000)
	    		
		    	}

		    }, // render message

		    render_no_found(){
		    	let vm = this;
		    	if (this.url_video !== vm.$URL) {

			    	vm.url_video = '';
					const timer_no_found = setTimeout(()=>{
						vm.url_video = vm.$URL;
						vm.onResize();
						this.pagination = {
	      					visible: 5,
							total: 1,			
							items: 0,
							found: true,
	      				};
	      				clearTimeout(timer_no_found);
						// vm.set_time_lapse();

					},1000)
		    	}else{
		    		console.log("Same url video no refresh");
		    		const timer_no_found = setTimeout(()=>{
						
						vm.onResize();
						this.pagination = {
	      					visible: 5,
							total: 1,			
							items: 0,
							found: true,
	      				};
	      				clearTimeout(timer_no_found);
						// vm.set_time_lapse();

					},1000)
		    	}
		    }, // render no found


		    fillData () {
		     	this.height = 100;
		        this.datacollection = {
		          labels: [this.getRandomInt(), this.getRandomInt()],
		          datasets: [
		            {
		              label: 'Data One',
		              backgroundColor: '#f87979',
		              data: [this.getRandomInt(), this.getRandomInt()]
		            }, {
		              label: 'Data 2',
		              backgroundColor: '#f87979',
		              data: [this.getRandomInt(), this.getRandomInt()]
		            },{
		              label: 'Data 3',
		              backgroundColor: '#f87979',
		              data: [this.getRandomInt(), this.getRandomInt()]
		            }
		          ]
		        }
		    },
		    getRandomInt () {
		        return Math.floor(Math.random() * (50 - 5 + 1)) + 5
		    }, // get random Int

		    select_tag(item){
		    	if (item) {

		    	}else{
		    		console.log("No found tag : ", item);
		    	}
		    }, // select tag

		    async get_list_trained(){
				let page  = 1,
		          	pages = 2,
		          	list  = []; 

		        while (page < pages){

					const api = this.$URL_face+'/api/face/list?page=' + page;
					
					const listed =  await  
					this.$axios.get(api).then( res => {
						
						let items 	= res.data.results;
		            	if (res.data.next){
		                  pages++;              
		                }
						
						if (page == 1) {			                
			                list = items;
			            }else{
			                list = list.concat(items)
			            }

			            return list;
						
					}).catch( er =>{
						console.log(er, 'error get list trained')
					})
					page++;		        
		    	}
		       	
		       	if (list && list.length > 0) {     
		       		this.list_entitys = list; 
		       		// this.lists.list_entity = list;
		       	}

			}, // get_list_trained
    	
  			render_analytic_option(key, item){

				console.log("key, item render option ", key, item);
		 		if (key == 'analytic') {
		 			let vm 				= this;
		 			let analytics 		= this.list_analytics; // this.list_analytics_tags; //
		 			let idx_analytic  	= null;
		 			if (!analytics.includes(item)) {
		 				idx_analytic = vm.info_search_fields.findIndex( x => x &&  x.ref_analytic == 'object' );
		 				/*let list_sel = 'list_' + item;
		 				if ( item != 'anomalies') {
		 					list_sel += 's';
		 				}
		 				vm.info_search_fields[idx_analytic].list = list_sel ;*/
		 			}else{
		 				idx_analytic = vm.info_search_fields.findIndex( x => x &&  x.ref_analytic == item );
		 			}
		 			console.log('idx_analytic', idx_analytic)
		 			if (idx_analytic >= 0) {
		 				if (vm.select_idx_analytic) {
		 					vm.info_search_fields[vm.select_idx_analytic].visible = false;
		 				}
		 				vm.select_idx_analytic  = idx_analytic;
		 				vm.info_search_fields[idx_analytic].visible = true;
		 			}
		 		}
		 	}, // render_analytic_option

		 	keyboard_is_active(keys, id_notification, type, obj ){
			    let key_board = false;
			    if (localStorage.getItem('virtual_Key_board')) {
			      key_board = JSON.parse(localStorage.getItem('virtual_Key_board'));
			    }       
			    console.log(key_board , "KEYbOARD ACTIVE ")
			    if (key_board) {              
			      /*if (this[keys]) {
			          this[keys] = '';
			      }*/
			      // keys         
			      EventBus.$emit('active_keyboard_key',{
			        ID   : id_notification,
			        key  : keys,
			        type,
			        obj
			      });
			    }       
			}, // keyboard_is_active

		 	onInputChange(input){
				console.log("on input change", input)
				this.input = input.target.value;
			}, // onInputChange

			FormatJsonToTimeline(rows){
				let  vm = this

                console.log("response", rows)
				/*{
				id: 0,
				group: 0,
				start: new Date(),
				content: 'Item 1'
				}*/
            	let list_temp = rows.timeline;
                let temp_tag  = [];
                let tags 	  = [];
                vm.items 	  = [];
                vm.items 	  = list_temp;
                // vm.tags_colors = [];
			}, // FormatJsonToTimeline

		}, // methods

		computed: {
			styles_charts: function(){
				return {
					height : `${this.height}'px'`,
					position : 'relative',
				}
			}, // styles charts 

		}, // computed

		mounted(){
			
			this.onResize();
			/*let line = document.getElementById('line-chart')
			line.styles.height = 200 + 'px';
			line.height = 200;

			if (line.getContext("2d")){
				let context = line.getContext('2d');
				context.canvas.height = 100; 
			}*/
			EventBus.$on('keyboard_type' + this.ID_notification, (action) =>{
				if (action) {
					console.log("INPUT TYPE : ",action.input)
					if (action.setting) {
						let { obj, key, type } =  action.setting;
						if (type == 'text') {
							this[key] = action.input;
						}else{
							this[obj][key] = action.input;
						}
					}
				}
			});

			console.log(this.$refs)
            let vm = this
            if (this.$refs && this.$refs.timeline) {
	            this.$refs.timeline.on('itemover',function (params) {
	                console.log("data",params)

	                vm.src_img = vm.$URL+vm.items.find( its =>{
	                  
	                    if(its.id == params.item){
	                        console.log(vm.src_img,"image")
	                        return its.evidence
	                    }   
	                }).evidence
					vm.set_url_video(vm.src_img, 'string');

	               
	                
	            })
	            this.$refs.timeline.on('rangechanged',function(data){
	                console.log("changed",data)
	     			//vm.items=[]
	           	 })
			} // if refs timeline
		}, // mounted
	};
</script>